export const categories = [
  {
    slug: "biaoqingbao",
    name: "表情包",
    shortName: "表情包",
    desc: "聊天斗图不求人，最新最火的表情包一次囤够",
    intro:
      "从吃瓜捂脸笑到猫咪叹气，这里收集当下群里最常用的表情包。每张都标注了适用场景，存下来就能用，聊天斗图再也不怕被抢答。",
    icon: "ri-emotion-happy-line",
    count: 1280,
  },
  {
    slug: "duanzi",
    name: "段子",
    shortName: "段子",
    desc: "三行之内必有笑点，通勤路上解闷专用",
    intro:
      "上班摸鱼、排队等餐、深夜失眠都能刷的短段子。取材自真实生活场景，妈妈逻辑、外卖备注、周报文学一应俱全，读完就能原地转发。",
    icon: "ri-chat-smile-2-line",
    count: 960,
  },
  {
    slug: "shenhuifu",
    name: "神回复",
    shortName: "神回复",
    desc: "一句话反杀，评论区才是主角",
    intro:
      "被老板问迟到、被亲戚催婚、被客服绕圈子，总有人能用一句话把场子接住。这里收录群众认证的教科书级神回复，句句值得背诵。",
    icon: "ri-reply-line",
    count: 3400,
  },
  {
    slug: "gengtu",
    name: "梗图",
    shortName: "梗图",
    desc: "一张图说完整句话，朋友圈发图更有底气",
    intro:
      "减肥第一天、凌晨三点的购物车、交房租的艺术，生活里那些说不清的瞬间，一张梗图就能讲明白。适合收藏后慢慢发。",
    icon: "ri-image-2-line",
    count: 1120,
  },
  {
    slug: "shipin",
    name: "二创视频",
    shortName: "视频",
    desc: "名场面混剪、方言配音、评论区再创作",
    intro:
      "把评论区神回复配成音、把表情包做成动画、把名场面重新剪一遍。二创视频频道收录网友的脑洞作品，短平快，随时开刷。",
    icon: "ri-video-line",
    count: 640,
  },
];

export const hotKeywords = [
  "吃瓜群众评论",
  "神回复",
  "表情包",
  "梗图",
  "方言配音",
  "打工人日常",
  "周末快乐",
  "群聊斗图",
];